import text from "./text";
import select from "./select";
import Switch from "./switch";
export default {
    text: text,
    select: select,
    "switch": Switch
};
